import React from 'react';
import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Grid
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { PlaceRounded } from '@material-ui/icons';

// Like https://github.com/brunobertolini/styled-by
const styledBy = (property, mapping) => (props) => mapping[props[property]];

const styles = {
  root: {
    background: styledBy('color', {
      teal: '#159587',
    }),
    '&:hover': {
      background: '#0E7066',
   },
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: styledBy('color', {
      default: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      blue: '0 3px 5px 2px rgba(33, 203, 243, .3)',
    }),
    fontSize: '0.9em',
    overflow: 'hidden',
    textAlign: 'center'
  },
};

const StyledButton = withStyles(styles)(({ classes, color, ...other }) => (
  <Button className={classes.root} {...other} />
));

const useStyles = makeStyles((theme) => ({
  cardHeaderTitle: {
    fontWeight: 'bold',
    marginBottom: '5px',
    fontSize: '1.2em',
    height: '2em',
  },
  cardSubheader: {
    fontSize: '0.9em',
  },
  cardMediaContainer: {
    overflow: 'hidden',
    position: 'relative',
  },
  recContainer: {
    position: 'absolute',
    top: '5px',
  },
  recLabel: {
    padding: '2px',
    marginBottom: '2px',
    backgroundColor: '#e69b13',
    textAlign: 'center',
    width: '120%',
    fontSize: '0.9em',
  },
}));

export default function MerchantCard(props) {
  const classes = useStyles();
  const { merchant } = props;

  const choosePromotionColor = (type) => {
    switch (type.toUpperCase()) {
      case 'WOW':
        return 'secondary';
      case 'SUPER':
        return 'secondary';
      case 'OMG':
        return 'secondary';
      default:
        return 'primary';
    }
  };

  return (
    <Card className="card">
      <CardHeader
        // avatar={
        //   <Avatar>{merchant.name[0].toUpperCase()}</Avatar>
        // }
        classes={{
          title: classes.cardHeaderTitle,
          subheader: classes.cardSubheader,
        }}
        title={merchant.name}
      // subheader={merchant.addressOne}
      />
      <div className={classes.cardMediaContainer}>
        <CardMedia
          component="img"
          className="media"
          image={merchant.imgUrl}
          title={merchant.name}
        />
        <div className={classes.recContainer}>
          {merchant.recommendations.length > 0 ? JSON.parse(merchant.recommendations).map((rec) => {
            return (
              <div className={classes.recLabel}>
                {rec}
              </div>
            )
          }) : <></>}
        </div>
      </div>
      <CardContent>
        {/* <div className='card-name'>
          {merchant.name}
        </div> */}
        <div className='card-category'>
          {JSON.parse(merchant.categories).join(', ')}
        </div>
        <div className='card-address'>
          {(() => {
            if (merchant.addressOne !== "") {
              return (
                <a className="link" target="_blank" rel="noopener noreferrer"
                  href={"https://www.google.com/maps/place/" + merchant.addressOne + " " + merchant.addressTwo + " " + merchant.postalCode}>
                  <PlaceRounded className="icon" style={{ fontSize: 40 }}></PlaceRounded>
                  <div className="info">
                    <div>
                      {merchant.addressOne}
                    </div>
                    <div>
                      {merchant.addressTwo}
                    </div>
                    <div>
                      {merchant.postalCode}
                    </div>
                  </div>
                </a>
              )
            } else {
              return (
                <p>
                  Select preferred outlet(s) in ordering site
                  <br/>
                  <br/>
                </p>
              )
            }
          })()}
        </div>
        <div className="card-description">
          {merchant.description}
        </div>
      </CardContent>
      <CardActions>
        <Grid container spacing={1}>
          {merchant.promotions.length === 1 ? 
            <Grid item xs={12}>
              <StyledButton
                variant="contained"
                target="_blank"
                fullWidth
                color="teal"
                href={merchant.promotions[0].url}
              >
                {(() => {
                  switch(merchant.promotions[0].type) {
                    case "Dollar":
                      return '$' + merchant.promotions[0].value + ' ' + merchant.promotions[0].name;
                    case "Percentage":
                      return merchant.promotions[0].value + '% ' + merchant.promotions[0].name;
                    case "Free":
                      return merchant.promotions[0].name;
                  }
                })()}
              </StyledButton>
            </Grid>
          : merchant.promotions.length > 1 ? merchant.promotions.map(promo => {
            return (
              <Grid item xs={12} md={6}>
                <StyledButton
                  variant="contained"
                  target="_blank"
                  fullWidth
                  color="teal"
                  href={promo.url}
                >
                  {promo.type === 'Dollar' ? '$' + promo.value : promo.value + '%'} {' '} {promo.name}
                </StyledButton>
              </Grid>
            )
          }) :
            <Grid item xs={12}>
              <StyledButton
                variant="contained"
                color="teal"
                target="_blank"
                fullWidth
                href={merchant.storeUrl}
              >
                Order Now
          </StyledButton>
            </Grid>
          }
        </Grid>
      </CardActions>
    </Card >
  )
}